



































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import { useBrowserRuleStore } from "@/admin/store/browserRule";
import { Validator } from "vee-validate";
import { BrowserIdentifier, browserNameMap } from "@/shared/types";
import { BrowserRuleAddRequest, BrowserRuleUpdateRequest, BrowserRule } from "@/admin/types";
import _ from "lodash";

interface FormModel {
  browser: BrowserIdentifier;
  minVersion: string;
  enabled: boolean;
}

const emptyFormModel: FormModel = {
  browser: BrowserIdentifier.None,
  minVersion: "",
  enabled: true
};

const browserOptions = Object.entries(browserNameMap).map(([value, text]) => ({
  text: text ? text : "-- Select a browser --",
  value: value as BrowserIdentifier
}));

@Component({})
export default class BrowserRuleEdit extends Vue {
  $validator: Validator;
  browserRuleStore = useBrowserRuleStore();

  formModel = _.cloneDeep(emptyFormModel);
  isSaving = false;
  browserOptions = browserOptions;

  @Prop({ required: true })
  isNew: boolean;

  @Prop({ required: true })
  browserRule: BrowserRule;

  @Prop({ required: true })
  show: { value: boolean };

  @Watch("show.value")
  onShowChanged () {
    if (this.show.value) {
      this.cloneToFormModel();
    } else {
      this.reset();
    }
  }

  get title () {
    return this.isNew ? "Add Browser" : "Edit Browser";
  }

  get saveDisabled () {
    return !this.isValid || this.isSaving;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  cloneToFormModel () {
    if (this.isNew || !this.browserRule) {
      return;
    }

    this.formModel = {
      browser: this.browserRule.browser,
      minVersion: this.browserRule.minVersion.toString(),
      enabled: this.browserRule.enabled
    };
  }

  onSave () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }

      this.isSaving = true;

      if (this.isNew) {
        this.onSaveNew();
      } else {
        this.onSaveExisting();
      }
    });
  }

  onSaveNew () {
    const rule: BrowserRuleAddRequest = {
      browser: this.formModel.browser,
      minVersion: Number(this.formModel.minVersion),
      enabled: this.formModel.enabled
    };

    this.browserRuleStore.addBrowserRule(rule)
      .then(() => this.close())
      .catch(() => {/*noop*/})
      .finally(() => {
        this.isSaving = false;
      });
  }

  onSaveExisting () {
    const rule: BrowserRuleUpdateRequest = {
      minVersion: Number(this.formModel.minVersion),
      enabled: this.formModel.enabled
    };

    this.browserRuleStore.updateBrowserRule({ browser: this.formModel.browser, rule })
      .then(() => this.close())
      .catch(() => {/*noop*/})
      .finally(() => {
        this.isSaving = false;
      });
  }

  close () {
    this.show.value = false;
  }

  reset () {
    this.formModel = _.cloneDeep(emptyFormModel);
    this.isSaving = false;
  }
}
